<template>
  <div>
    <Dialog
      :dismissableMask="true"
      :style="{ width: '50vw' }"
      :modal="true"
      :visible.sync="show"
      @hide="closeDialog"
      :contentStyle="{ overflow: 'visible' }"
    >
      <template #header>
        <i style="transform: scale(1.7)" class="pi pi-briefcase"></i>
        <h1>דיווח משמעת</h1>
      </template>

      <div class="p-pt-4 p-jc-center p-grid">
        <!--   pupil  -->
        <div class="p-field p-col-6">
          <label>שם התלמיד</label>
          <Dropdown
            filterPlaceholder=" חפש לפי שם משפחה"
            emptyFilterMessage=" לא נמצא שם משפחה תואם"
            class="p-dropdown-filter-container"
            :filter="true"
            optionLabel="lastname"
            v-model="newItem.pupil"
            :options="pupils"
            placeholder="בחר תלמיד"
            dataKey="id"
          >
            <template #value="slotProps">
              <div v-if="!slotProps.value || slotProps.value.length === 0">
                {{ slotProps.placeholder }}
              </div>
              <span v-else>
                {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
              </span>
            </template>
            <template #option="slotProps">
              <span
                >{{ slotProps.option.grade.hebrewName }}:
                {{ slotProps.option.firstname }}
                {{ slotProps.option.lastname }}</span
              >
            </template>
          </Dropdown>
        </div>

        <!--   teacher  -->
        <div v-if="user.role === 'ADMIN'" class="p-field p-col-6">
          <label>מורה השייך לאירוע</label>
          <Dropdown
            filterPlaceholder=" חפש לפי שם משפחה"
            emptyFilterMessage=" לא נמצא שם משפחה תואם"
            class="p-dropdown-filter-container"
            :filter="true"
            optionLabel="lastname"
            v-model="newItem.teacher"
            :options="teachers"
            placeholder="בחר מורה"
            dataKey="id"
          >
            <template #value="slotProps">
              <div v-if="!slotProps.value || slotProps.value.length === 0">
                {{ slotProps.placeholder }}
              </div>
              <span v-else>
                {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
              </span>
            </template>
            <template #option="slotProps">
              <span>
                {{ slotProps.option.firstname }}
                {{ slotProps.option.lastname }}</span
              >
            </template>
          </Dropdown>
        </div>

        <!--   content  -->

        <div class="p-field p-col-12">
          <label>תוכן האירוע</label>
          <div class="p-col-12 twrap p-d-flex p-jc-center">
            <Textarea
              cols="30"
              placeholder="תוכן האירוע"
              type="text"
              v-model="newItem.content"
            />
          </div>
        </div>

        <!--   subject  -->
        <div class="p-field p-col-4">
          <label>סוג האירוע</label>
          <Dropdown
            :filter="true"
            v-model="newItem.subject"
            :options="subjectTracingFilter"
            placeholder="בחר את סוג האירוע"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span class="subject-tracking" :class="slotProps.value.type"
                  >{{ slotProps.value.hebrewName }}
                </span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span class="subject-tracking" :class="slotProps.option.type"
                >{{ slotProps.option.hebrewName }}
              </span>
            </template>
          </Dropdown>
        </div>

        <!--   date  -->
        <div class="p-field p-col-4">
          <label>תאריך האירוע</label>

          <Calendar
            :showButtonBar="true"
            :showTime="true"
            dateFormat="dd.mm.yy"
            v-model="newItem.date"
            placeholder="תאריך"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="ביטול"
          icon="pi pi-times"
          @click="closeDialog"
          class="p-button-secondary"
        />
        <Button
          class="p-button-success"
          label="הוספה"
          icon="pi pi-check"
          @click="post"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../service/Service";
import { mapState } from "vuex";

const { v4: uuidv4 } = require("uuid");

export default {
  service: null,
  props: {
    teachers: Array,
    show: Boolean,
  },
  created() {
    this.service = new Service();
    this.setNewItwmFields();
  },
  computed: {
    ...mapState([
      "presenceStatus",
      "pupils",
      "subjectTracing",
      "user",
      "subjectLesson",
      "gradeOptions",
    ]),
    subjectTracingFilter() {
      if (this.user.role !== "ADMIN") {
        return this.subjectTracing.filter((s) => s.role !== "ADMIN");
      } else {
        return this.subjectTracing;
      }
    },
  },
  data() {
    return {
      newItem: null,
      postLock: false,
    };
  },

  methods: {
    getGradeObj(gradeId) {
      return this.gradeOptions.find((grade) => grade.id === gradeId);
    },
    setNewItwmFields() {
      this.newItem = {
        id: uuidv4(),
        date: new Date(),
        content: null,
        subject: null,
        pupil: null,
        user: null,
        teacher: null,
        grade: null,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      // for (const key in this.newItem) {
      //   if (this.newItem[key] === null) {
      //     validate = false;
      //   }
      // }
      if (!this.postLock) {
      }
      if (validate === true) {
        this.postLock = true;

        if (this.newItem.teacher === null) {
          this.newItem.teacher = {
            id: this.user.id,

            firstname: this.user.firstname,
            lastname: this.user.lastname,
          };
        }
        const subjectTracingObj = JSON.parse(
          JSON.stringify(this.newItem.subject)
        );
        const pupilObj = JSON.parse(JSON.stringify(this.newItem.pupil));
        const gradeObj = JSON.parse(JSON.stringify(this.newItem.pupil.grade));
        const teacherObj = JSON.parse(JSON.stringify(this.newItem.teacher));

        const Obj = JSON.parse(JSON.stringify(this.newItem));
        Obj.date = Date.parse(Obj.date);
        Obj.subject = Obj.subject.id;
        Obj.grade = pupilObj.grade.id;
        Obj.pupil = pupilObj.id;
        if (this.newItem.teacher.id !== undefined) {
          Obj.teacher = Obj.teacher.id;
        }
        Obj.user = this.user.id;
        Obj.enabled = false;

        await this.service
          .post(Obj, "tracing")
          .then(() => {
            Obj.subject = subjectTracingObj;
            Obj.pupil = pupilObj;
            Obj.grade = gradeObj;
            Obj.teacher = teacherObj;

            // if (!teacherObj) {
            //   Obj.teacher = {
            //     id: this.user.id,

            //     firstname: this.user.firstname,
            //     lastname: this.user.lastname,
            //   };
            // }
            Obj.user = {
              id: this.user.id,

              firstname: this.user.firstname,
              lastname: this.user.lastname,
            };
            this.$emit("addItem", Obj);
            this.setNewItwmFields();
            this.openNotification("success", `מעולה`, `המשתמש התתוסף במערכת`);
            this.postLock = false;

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר משתמש עם ת.ז. זהה`
            );
            this.postLock = false;
          });
      } else {
        this.openNotification("danger", `אופס`, `חסרים כמה שדות למילוי`);
      }
    },

    openNotification(
      color,
      title,
      text,
      position = "right-left",
      duration = 3000
    ) {
      this.$vs.notification({
        color,
        position,
        title,
        text,
        duration,
        progress: "auto",
      });
    },
  },
};
</script>

<style>
/*.p-dialog-header{*/
/*  background:  #fbbf2c !important;*/
/*}*/
</style>
